'use client'
import moment from 'moment'
import CustomTableHead from '@/Component/Common/Tables/CustomTableHead'
import { AdminCampaignStatusChangeAPI, CategoryAPI, CategoryActiveInActiveAPI, UserStatusChangeAPI } from '@/Utils/APIRequest/Endpoints'
import { CustomToast } from '@/Utils/CustomToast'
import TableHoc from '@/Utils/HOC/TableHoc'
import usePost from '@/Utils/Hooks/usePost'
import ActiveDeactiveStatus from '@/Component/Common/Tables/ActiveDeactiveStatus'
import { TableDeleteSVG, TableEditSVG, TableEyeSVG } from '@/Component/Common/SVGs/CommonSVG'
import NoDataTable from '@/Component/Common/Tables/NoData/NoDataTable'
import ConfirmationModal from '@/Component/Common/Modal/ConfirmationModal'
import Link from 'next/link'
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas'

const AdminCampaignTable = (props) => {
    const { deleteModal, modal, setDeleteModal, setModal, apiData, translations } = props
    const CampaignData = apiData?.data?.data

    // API DELETE
    const { isPending: deleteLoader, mutate } = usePost(`${CategoryAPI}/${deleteModal?.id}`, null, (response) => {
        if (response.status == 200 || response.status == 204 || response.status == 201) {
            CustomToast("success", 'Campaign deleted successfully')
            apiData?.refetch()
            setDeleteModal(null)
        }
    }, 'delete')

    const tableHeadData = {
        head: [
            { title: "Sr No.", sorting: false },
            { title: "Campaign Name", apiKey: "campaign_name", sorting: true },
            { title: "Influencer Type", apiKey: "influencer_type", sorting: true },
            { title: "Profile Privacy", apiKey: "profile_privacy", sorting: true },
            { title: "Total Budget", apiKey: "total_budget", sorting: true },
            { title: "Budget Per Influencer", apiKey: "budget_per_influencer", sorting: true },
            { title: "Campaign", apiKey: "status", sorting: true },
            { title: "Status", apiKey: "is_active", sorting: true },
            { title: "Created At", apiKey: "created_at", sorting: true },
            { title: "Action", sorting: false },
        ]
    }

    const callbackFunction = () => {
        mutate()
    }
    return (
        <>
            <table className="w-full text-sm text-left rtl:text-right">
                <CustomTableHead tableHeadData={tableHeadData} params={apiData?.params} setParams={apiData?.setParams} />
                <tbody>
                    {
                        CampaignData?.length > 0
                            ?
                            CampaignData?.map((campaign, index) => (
                                <tr className="border-b border-lightGray last:border-none font-normal hover:bg-lightGray/20 align-middle" key={index}>
                                    <td className="px-5 py-4">
                                        {((apiData?.params.page - 1) * apiData?.params.per_page) + 1 + index}
                                    </td>
                                    <td className="px-5 py-4 w-56  whitespace-nowrap">
                                        {campaign?.campaign_name}
                                    </td>
                                    <td className="px-5 py-4 w-56  whitespace-nowrap">
                                        {campaign?.influencer_type}
                                    </td>
                                    <td className="px-5 py-4 w-56  whitespace-nowrap capitalize">
                                        {campaign?.profile_privacy}
                                    </td>
                                    <td className="px-5 py-4 w-56  whitespace-nowrap">
                                        {campaign?.total_budget > 0 ? `${formatNumberWithCommas(campaign?.total_budget)} ${campaign?.currency}` : "N/A"}
                                    </td>
                                    <td className="px-5 py-4 w-56  whitespace-nowrap">
                                        ${formatNumberWithCommas(campaign?.budget_per_influencer)} {campaign?.currency}
                                    </td>
                                    <td className="px-5 py-4 ">
                                        <span className={`capitalize text-xs py-1 px-3 rounded-md ${campaign?.status == 'running' ? 'bg-gradient-to-tr from-secondary to-primary text-white' : 'bg-green-500 text-white'}`}>
                                        {campaign?.status}
                                        </span>
                                    </td>
                                    <ActiveDeactiveStatus data={campaign} apiProps={{ endpoint: `${AdminCampaignStatusChangeAPI}/${campaign?.id}`, path: null }} refetch={apiData?.refetch} translations={translations} />
                                    <td className="px-5 py-4">
                                        {moment.utc(campaign?.created_at).local().format('DD MMM YYYY')}
                                    </td>
                                    <td className="px-5 py-4">
                                        <div className="flex items-center">
                                            <Link href={`/admin/campaigns/${campaign?.slug}`} className='mr-3 p-0.5'>
                                                <TableEyeSVG />
                                            </Link>
                                        </div>
                                    </td>
                                </tr>
                            ))
                            : <NoDataTable colSpan={9} />
                    }
                </tbody>
            </table>
        </>
    )
}

export default TableHoc(AdminCampaignTable)